import { updateViewedProducts } from '@/components/helpers/product'

function handleProductLoad() {
  if (typeof window.productSku === 'undefined') return
  updateViewedProducts(window.productSku)
}

handleProductLoad()
